import { render, staticRenderFns } from "./EmployerCandidates.vue?vue&type=template&id=a97b6f80&scoped=true"
import script from "./EmployerCandidates.vue?vue&type=script&lang=js"
export * from "./EmployerCandidates.vue?vue&type=script&lang=js"
import style0 from "./EmployerCandidates.vue?vue&type=style&index=0&id=a97b6f80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97b6f80",
  null
  
)

export default component.exports